import { ToastProps } from './Toast';
import { toastEvent } from './ToastContainer';

export const AddToastEvent = 'addToast';

export const toast = (args: ToastProps) => {
  toastEvent.emit(AddToastEvent, args);
};
